<template>
  <div>
    <div class="ch-head">
      <div>
        <h1>子账号管理</h1>
        <p>子账号是本商户内部员工，不需要企业信息。开设渠道商账号请到「下级管理」。</p>
      </div>
      <div class="ch-actions">
        <button class="ch-btn gold" type="button" @click="open = true">创建子账号</button>
      </div>
    </div>
    <div class="ch-metrics three">
      <div class="ch-metric"><div class="k">子账号</div><div class="v">{{ list.length }} 个</div></div>
      <div class="ch-metric"><div class="k">在用</div><div class="v">{{ active }} 个</div></div>
      <div class="ch-metric"><div class="k">已停用</div><div class="v">{{ list.length - active }} 个</div></div>
    </div>
    <div class="ch-panel">
      <table class="ch-table">
        <thead><tr><th>姓名</th><th>登录账号</th><th>岗位</th><th>手机</th><th>状态</th></tr></thead>
        <tbody>
          <tr v-for="row in list" :key="row.id">
            <td>{{ row.realName || row.name }}</td>
            <td>{{ row.username }}</td>
            <td>{{ row.title || '—' }}</td>
            <td>{{ row.phone || '—' }}</td>
            <td><span class="ch-tag" :class="row.status === 1 ? 'ok' : 'muted'">{{ row.status === 1 ? '在用' : '停用' }}</span></td>
          </tr>
          <tr v-if="!list.length"><td colspan="5" class="ch-empty">还没有子账号</td></tr>
        </tbody>
      </table>
      <p class="ch-note" style="margin-top:12px">角色权限矩阵和安全日志还没有按岗位拆开。当前子账号登录后看到的菜单与主账号相同。</p>
    </div>
    <el-dialog title="创建子账号" :visible.sync="open" width="420px">
      <el-form label-width="70px" size="small">
        <el-form-item label="姓名"><el-input v-model="form.name" /></el-form-item>
        <el-form-item label="手机"><el-input v-model="form.phone" maxlength="11" placeholder="作为登录账号" /></el-form-item>
        <el-form-item label="岗位"><el-input v-model="form.title" placeholder="财务 / 业务" /></el-form-item>
      </el-form>
      <p class="ch-note">登录账号就是这个手机号。创建后给出初始密码，在登录页的用户名处填写手机号即可。</p>
      <div slot="footer">
        <el-button size="small" @click="open = false">取消</el-button>
        <el-button size="small" type="primary" @click="submit">确认创建</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getChannelOverview, getChannelStaff, addChannelStaff } from '@/api/admin'

export default {
  name: 'PartnerStaff',
  data() {
    return { partnerId: null, list: [], open: false, form: { name: '', phone: '', title: '业务' } }
  },
  computed: {
    active() { return this.list.filter(item => item.status === 1).length }
  },
  created() { this.load() },
  methods: {
    async load() {
      const overview = await getChannelOverview()
      this.partnerId = overview.partnerId
      const staff = await getChannelStaff()
      this.list = staff.list || []
    },
    async submit() {
      const phone = String(this.form.phone || '').trim()
      if (!/^1\d{10}$/.test(phone)) {
        this.$message.warning('请填写11位手机号，登录账号使用该手机号')
        return
      }
      this.form.phone = phone
      const result = await addChannelStaff(this.partnerId, this.form)
      this.open = false
      this.$alert(`登录账号 ${result.loginName}，初始密码 ${result.initialPassword}。登录页用户名处填写该手机号。`, '子账号已开通')
      this.form = { name: '', phone: '', title: '业务' }
      this.load()
    }
  }
}
</script>
